import { theme } from './utils/theme-preval';
export default theme;

// Experimental; these all need to be rebuilt with the correct naming conventions
// None of these color roles (except surface.default) really map to Atlassian's naming conventions (which is in flux)
// We need to establish our own tokens system

// ThemeColors and ThemeShadows are handcrafted types. It would be nice if these
// were exports from the style variables package. They are definitely going to assume a different shape.